export default "__VITE_ASSET__De00dDvi__"